import { Provider, Injector } from '@angular/core';
import { TIME_PROVIDER } from '../tokens/time-provider.token';
import { MobileTimeService } from '../services/mobile-time.service';
import { TimeService } from '../services/time.service';
import { isFromMobileApp } from '../helpers';

export function timeProviderFactory(injector: Injector) {
  return isFromMobileApp()
    ? injector.get(MobileTimeService)
    : injector.get(TimeService);
}

export const TIME_PROVIDER_PROVIDER: Provider = {
  provide: TIME_PROVIDER,
  useFactory: timeProviderFactory,
  deps: [Injector],
};
